import React from "react";

/**
 * SafeBoundary – lokaler Render-Crash-Schutz für einzelne Sub-Trees.
 *
 * Anders als der globale AppErrorBoundary (`/components/AppErrorBoundary.jsx`),
 * der das gesamte UI umrahmt und im Crash-Fall die "Seite neu laden"-Karte
 * zeigt, fängt diese Variante einen Crash innerhalb eines einzelnen Widgets
 * ab und rendert wahlweise nichts oder einen schlanken Fallback. So
 * verschwindet bei einem Crash z. B. nur ein Diagramm – der umliegende Tab
 * bleibt benutzbar.
 *
 * Verwendung:
 *   <SafeBoundary>
 *     <KomponenteDieEvtlCrashed />
 *   </SafeBoundary>
 */
export class SafeBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("[SafeBoundary] suppressed render error:", error?.message, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}

export default SafeBoundary;
